import React from 'react';
import './CardContent.scss';

interface Props {
  children: React.ReactNode;
}

const CardContent: React.FC<Props> = ({ children }) => {
  return <div className="ui-kit-card-content">{children}</div>;
};

export default CardContent;
